import { render, staticRenderFns } from "./taobao_shangou.vue?vue&type=template&id=d92f1e20&scoped=true&"
import script from "./taobao_shangou.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou.vue?vue&type=style&index=0&id=d92f1e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92f1e20",
  null
  
)

export default component.exports